import React, { useMemo } from "react";
import {
    GridRenderEditCellParams,
    GridSingleSelectColDef,
    useGridApiContext,
} from "@mui/x-data-grid-premium";
import { AutocompleteOption, AutocompleteWrapper } from "../muiAutocomplete";
import { useTranslation } from "react-i18next";

export const MuiDataGridAutoComplete = ({
    id,
    field,
    value,
    hasFocus,
    colDef,
}: GridRenderEditCellParams) => {
    const apiRef = useGridApiContext();
    const { valueOptions } = colDef as GridSingleSelectColDef;
    const { t } = useTranslation();

    const handleValueChange = async(newValue: string | null) => {
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: newValue,
        });
    };

    const options: AutocompleteOption[] = useMemo(
        () =>
            (valueOptions as { value: string; label: string }[])?.map((o) => ({
                id: o.value,
                title: o.label,
            })) ?? [],
        [valueOptions]
    );

    return (
        <AutocompleteWrapper
            options={options}
            size="small"
            defaultOpen={hasFocus}
            value={value}
            placeholder={t("common.typeToSeeOptions")}
            onChange={(val: AutocompleteOption) =>
                void handleValueChange(val?.id ?? null)
            }
            fullWidth
            textFieldProps={{
                size: "small",
                variant: "standard",
                sx: { fontSize: "0.875rem" },
            }}
        />
    );
};
